<template>
  <v-row no-gutters class="pt-4" v-if="show">
    <v-col lg="10" md="10" cols="12">
      <component :is="banner.url ? 'a' : 'div'" :href="banner.url || undefined" target="_blank" rel="noopener">
        <v-img class="hidden-sm-and-down" :aspect-ratio="1920 / 400" :src="desktopSrc"></v-img>
        <v-img class="hidden-md-and-up" :aspect-ratio="828 / 368" :src="mobileSrc"></v-img>
      </component>
    </v-col>
  </v-row>
</template>

<script>
import { uiHelper } from '@/util'

export default {
  name: 'depositBanner',
  computed: {
    banner() {
      return this.$store.state.payment.depositBanner || {}
    },
    // gotcha: this.language is undefined in this codebase, always read uiHelper
    lang() {
      return uiHelper.getLanguage() === 'bd' ? 'bd' : 'en'
    },
    desktop() {
      return this.banner.desktop || {}
    },
    mobile() {
      return this.banner.mobile || {}
    },
    desktopSrc() {
      return this.desktop[this.lang] || this.desktop.en
    },
    mobileSrc() {
      return this.mobile[this.lang] || this.mobile.en || this.desktopSrc
    },
    show() {
      return !!(this.banner.enabled && this.desktopSrc)
    }
  }
}
</script>
